<template>
  <div class="address-container app-page">
    <div class="address-workbench">
      <div class="address-actions-bar">
        <el-button type="primary" @click="handleAdd" class="add-btn">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          新增地址
        </el-button>
      </div>

      <div class="address-table-wrap">
        <el-table
          :data="addressList"
          style="width: 100%"
          class="address-table"
        >
          <el-table-column prop="receiver" label="收件人" width="120">
            <template #default="scope">
              <div class="cell-highlight">{{ scope.row.receiver }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="联系电话" width="160"></el-table-column>
          <el-table-column prop="addressDetail" label="详细地址" min-width="300">
            <template #default="scope">
              <div class="address-cell-text">{{ scope.row.addressDetail }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="isDefault"
            label="是否默认"
            width="110"
            :formatter="formatDefault"
          >
            <template #default="scope">
              <el-tag v-if="scope.row.isDefault === 1" type="primary" class="default-tag-badge">默认地址</el-tag>
              <span v-else class="not-default">否</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="240"
            fixed="right"
          >
            <template #default="scope">
              <div class="table-actions">
                <el-button
                  type="text"
                  class="action-link"
                  @click="handleEdit(scope.row)"
                  :disabled="scope.row.isDefault === 1"
                >
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                  编辑
                </el-button>
                <el-button
                  type="text"
                  class="action-link danger"
                  @click="handleDelete(scope.row)"
                  :disabled="scope.row.isDefault === 1"
                >
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>
                  删除
                </el-button>
                <el-button
                  type="text"
                  class="action-link default-action"
                  @click="handleSetDefault(scope.row)"
                  :disabled="scope.row.isDefault === 1"
                >
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
                  设为默认
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 空状态 -->
        <div v-if="addressList.length === 0" class="empty-address">
          <el-empty description="暂无收货地址，请添加"></el-empty>
        </div>
      </div>
    </div>

    <!-- 地址表单弹窗 -->
    <el-dialog
      v-model="formVisible"
      :title="formTitle"
      width="500px"
      @close="handleFormClose"
      class="address-form-dialog"
    >
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="收件人" prop="receiver">
          <el-input v-model="form.receiver" placeholder="请输入收件人姓名"></el-input>
        </el-form-item>

        <el-form-item label="联系电话" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入联系电话"></el-input>
        </el-form-item>

        <el-form-item label="详细地址" prop="addressDetail">
          <el-input
            v-model="form.addressDetail"
            type="textarea"
            :rows="3"
            placeholder="请输入详细地址"
          ></el-input>
        </el-form-item>

        <el-form-item label="设为默认地址">
          <el-switch
            v-model="form.isDefault"
            active-value="1"
            inactive-value="0"
          ></el-switch>
        </el-form-item>
      </el-form>

      <template #footer>
        <el-button @click="handleFormClose">取消</el-button>
        <el-button type="primary" @click="handleFormSubmit">确定</el-button>
      </template>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog
      v-model="deleteDialogVisible"
      title="确认删除"
      width="400px"
      @close="deleteDialogVisible = false"
      class="confirm-dialog"
    >
      <div class="confirm-content">
        <svg viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="#f56c6c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        <p>确定要删除该地址吗？</p>
      </div>
      <template #footer>
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmDelete">
          确认删除
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive, toRefs } from 'vue'
import axios from 'axios'
import { ElMessage } from 'element-plus'

// 基础API路径
const BASE_URL = '/product-service/api/address'

// 地址相关API
const addressApi = {
  // 获取地址列表
  getList: (userId) => axios.get(`${BASE_URL}/list`, { params: { userId } }),
  // 新增地址
  add: (data) => axios.post(`${BASE_URL}/add`, data),
  // 更新地址
  update: (data) => axios.post(`${BASE_URL}/update`, data),
  // 删除地址
  delete: (id, userId) => axios.delete(`${BASE_URL}/delete`, { params: { id, userId } }),
  // 设置默认地址
  setDefault: (id, userId) => axios.post(`${BASE_URL}/update`, { id, userId, isDefault: 1 })
}

// 状态管理
const state = reactive({
  addressList: [],
  formVisible: false,
  form: {
    id: null,
    userId: 1, // 实际项目中从登录状态获取
    receiver: '',
    phone: '',
    addressDetail: '',
    isDefault: '0'
  },
  formTitle: '新增地址',
  deleteDialogVisible: false,
  currentDeleteId: null,
  rules: {
    receiver: [
      { required: true, message: '请输入收件人', trigger: 'blur' }
    ],
    phone: [
      { required: true, message: '请输入联系电话', trigger: 'blur' },
      { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
    ],
    addressDetail: [
      { required: true, message: '请输入详细地址', trigger: 'blur' }
    ]
  }
})

const {
  addressList,
  formVisible,
  form,
  formTitle,
  deleteDialogVisible,
  currentDeleteId,
  rules
} = toRefs(state)

// 表单引用
const formRef = ref(null)

// 初始化加载地址列表
onMounted(() => {
  fetchAddressList()
})
const userId = localStorage.getItem('userId')

// 获取地址列表
const fetchAddressList = async () => {
  try {

    const res = await addressApi.getList(userId)
    console.log(userId)
    addressList.value = res.data.data
  } catch (error) {
    ElMessage.error('获取地址列表失败：' + (error.response?.data?.msg || error.message))
  }
}

// 格式化默认地址显示
const formatDefault = (row) => {
  return row.isDefault === 1 ? '是' : '否'
}

// 新增地址
const handleAdd = () => {
  form.value = {
    id: null,
    userId: userId,
    receiver: '',
    phone: '',
    addressDetail: '',
    isDefault: '0'
  }
  formTitle.value = '新增地址'
  formVisible.value = true
}

// 编辑地址
const handleEdit = (row) => {
  form.value = {
    ...row,
    isDefault: row.isDefault.toString()
  }
  formTitle.value = '编辑地址'
  formVisible.value = true
}

// 关闭表单弹窗
const handleFormClose = () => {
  formVisible.value = false
  if (formRef.value) {
    formRef.value.clearValidate()
  }
}

// 提交表单（新增/编辑）
const handleFormSubmit = async () => {
  // 表单验证
  const valid = await formRef.value.validate()
  if (!valid) return

  try {
    // 转换isDefault为数字
    const submitData = {
      ...form.value,
      isDefault: parseInt(form.value.isDefault)
    }

    // 新增或编辑
    if (submitData.id) {
      await addressApi.update(submitData)
    } else {
      await addressApi.add(submitData)
    }

    ElMessage.success(formTitle.value === '新增地址' ? '添加成功' : '修改成功')
    handleFormClose()
    fetchAddressList()
  } catch (error) {
    ElMessage.error('提交失败：' + (error.response?.data?.msg || error.message))
  }
}

// 处理删除
const handleDelete = (row) => {
  currentDeleteId.value = row.id
  deleteDialogVisible.value = true
}

// 确认删除
const confirmDelete = async () => {
  try {
    await addressApi.delete(currentDeleteId.value, userId)
    ElMessage.success('删除成功')
    deleteDialogVisible.value = false
    fetchAddressList()
  } catch (error) {
    ElMessage.error('删除失败：' + (error.response?.data?.msg || error.message))
  }
}

// 设置默认地址
const handleSetDefault = async (row) => {
  try {
    await addressApi.setDefault(row.id, Number(userId))
    ElMessage.success('设置默认地址成功')
    fetchAddressList()
  } catch (error) {
    ElMessage.error('设置失败：' + (error.response?.data?.msg || error.message))
  }
}

</script>

<style scoped>
.address-container {
  max-width: 1200px;
  margin: 0 auto;
}

.address-workbench {
  background: var(--app-bg-card);
  border-radius: var(--app-radius-xl);
  box-shadow: var(--app-shadow-card);
  border: 1px solid var(--app-border-subtle);
  padding: 24px;
}

.address-actions-bar {
  margin-bottom: 20px;
}

.add-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px !important;
  border-radius: var(--app-radius-lg) !important;
  font-weight: 500 !important;
}

.address-table-wrap {
  overflow: hidden;
}

.address-table {
  border-radius: var(--app-radius-lg);
  overflow: hidden;
}

.address-table :deep(.el-table__header th) {
  background: var(--app-bg-soft) !important;
  color: var(--app-text-secondary);
  font-weight: 600;
  font-size: 0.875rem;
}

.address-table :deep(.el-table__body td) {
  padding: 14px 0 !important;
}

.address-table :deep(.el-table__body tr:hover td) {
  background: var(--app-color-primary-muted) !important;
}

.cell-highlight {
  font-weight: 600;
  color: var(--app-text-primary);
}

.address-cell-text {
  color: var(--app-text-secondary);
  line-height: 1.5;
}

.default-tag-badge {
  border-radius: var(--app-radius-full);
  padding: 0 10px;
  font-size: 0.75rem;
}

.not-default {
  color: var(--app-text-muted);
  font-size: 0.875rem;
}

.table-actions {
  display: flex;
  gap: 4px;
}

.action-link {
  font-size: 0.8125rem !important;
  color: var(--app-text-secondary) !important;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px !important;
  border-radius: var(--app-radius-sm) !important;
  transition: all 0.2s ease !important;
}

.action-link:hover:not(:disabled) {
  color: var(--app-color-primary) !important;
  background: var(--app-color-primary-soft) !important;
}

.action-link.danger:hover:not(:disabled) {
  color: #f56c6c !important;
  background: rgba(245, 108, 108, 0.08) !important;
}

.action-link.default-action:hover:not(:disabled) {
  color: #1677ff !important;
  background: rgba(22, 119, 255, 0.08) !important;
}

.empty-address {
  margin-top: 40px;
  text-align: center;
}

/* Dialog */
:deep(.address-form-dialog .el-dialog__header) {
  padding: 20px 24px 16px;
  border-bottom: 1px solid var(--app-border-light);
}

:deep(.address-form-dialog .el-dialog__body) {
  padding: 24px;
}

:deep(.el-dialog__title) {
  font-size: 1.125rem;
  font-weight: 600;
}

.confirm-content {
  text-align: center;
  padding: 20px 0;
}

.confirm-content p {
  margin: 16px 0 0;
  font-size: 1rem;
  color: var(--app-text-primary);
}

@media (max-width: 768px) {
  .address-workbench {
    padding: 16px;
  }

  .table-actions {
    flex-direction: column;
    gap: 2px;
  }
}
</style>
